import "./styles.css";
import PhoneInputLib from "react-phone-number-input";
import "react-phone-number-input/style.css";

interface Props {
    value: string | undefined;
    onChange: (value: string | undefined) => void;
    placeholder?: string;
    disabled?: boolean;
}

export default function PhoneInput({ value, onChange, placeholder, disabled }: Props) {
    return (
        <div className="phone-input-wrap">
            <PhoneInputLib international defaultCountry="SA" value={value} onChange={onChange} placeholder={placeholder} disabled={disabled} />
        </div>
    );
}
